import { render, staticRenderFns } from "./addLocationCate.vue?vue&type=template&id=ae183d70&scoped=true"
import script from "./addLocationCate.vue?vue&type=script&lang=js"
export * from "./addLocationCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae183d70",
  null
  
)

export default component.exports